import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GbNgrxAuthBasicModule } from '@geekbears/gb-ngrx-auth-basic';
import { ReactiveFormsModule } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { NgOtpInputModule } from 'ng-otp-input';

import { AuthenticationRoutingModule } from './presentation/authentication-routing.module';
import {
  LoginPage,
  ForgotPasswordComponent,
  PersonalInformationComponent,
  PasswordCodeComponent,
  NewPasswordComponent,
  IsBlockedComponent,
  SignUpPage,
  CompanyInformationComponent,
  PickAPlanComponent,
  ChangeDefaultPasswordComponent,
  ConfirmAccountComponent,
  OrganizationInformationComponent,
  AccountInformationComponent,
  SignupSelectionPage,
  JoinOrganizationPage,
  AdminSignUpPage,
  SignupInfoPage,
  ThankYouPage,
} from './presentation';
import { UsersServices } from '@modules/company-manager/users/domain';
import { UsersServicesImpl } from '@modules/company-manager/users/infrastructure';
import {
  UsersStoreModule,
  UsersEffectsModule,
} from '@modules/company-manager/users/application';
import {
  ProfileEffectsModule,
  ProfileStoreModule,
} from '@modules/regular-user/profile/application';
import { ProfileServices } from '@modules/regular-user/profile/domain';
import { ProfileServicesImpl } from '@modules/regular-user/profile/infrastructure';
import {
  MembershipEffectsModule,
  MembershipStoreModule,
} from '@modules/company-manager/membership/application';
import { MembershipServicesImpl } from '@modules/company-manager/membership/infrastructure';
import { MembershipServices } from '@modules/company-manager/membership/domain';
import { SharedModule } from '@modules/shared/shared.module';
import { RegisterComponent } from './presentation/pages/register/register.component';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { registerReducer } from '@modules/authentication/presentation/application/register/register.reducer';
import { RegisterEffects } from '@modules/authentication/presentation/application/register/register.effects';
const pages = [
  ForgotPasswordComponent,
  PersonalInformationComponent,
  PasswordCodeComponent,
  NewPasswordComponent,
  LoginPage,
  ChangeDefaultPasswordComponent,
  ConfirmAccountComponent,
  IsBlockedComponent,
  SignUpPage,
  CompanyInformationComponent,
  PickAPlanComponent,
  RegisterComponent,
  OrganizationInformationComponent,
  AccountInformationComponent,
  SignupSelectionPage,
  JoinOrganizationPage,
  AdminSignUpPage,
  SignupInfoPage,
  ThankYouPage,
];
@NgModule({
  providers: [
    {
      provide: UsersServices,
      useClass: UsersServicesImpl,
    },
    {
      provide: ProfileServices,
      useClass: ProfileServicesImpl,
    },
    {
      provide: MembershipServices,
      useClass: MembershipServicesImpl,
    },
  ],
  declarations: [...pages],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AuthenticationRoutingModule,
    GbNgrxAuthBasicModule,
    SharedModule,
    MatMenuModule,
    UsersStoreModule,
    UsersEffectsModule,
    ProfileStoreModule,
    ProfileEffectsModule,
    MembershipEffectsModule,
    MembershipStoreModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatBottomSheetModule,
    NgOtpInputModule,
    StoreModule.forFeature('register', registerReducer),
    EffectsModule.forFeature([RegisterEffects]),
  ],
})
export class AuthenticationModule {}
